import { usePalletsTypes } from 'constants/palletTypes';
import { PalletSpecification } from 'interfaces';

export const getPalletsFullData = <T>(
   pallets: T[],
   findPredicate: (pallet: T) => (palletType: PalletSpecification) => boolean,
   palletTypesData: ReturnType<typeof usePalletsTypes>['palletTypesData'],
) =>
   pallets.map((pallet: T) => {
      const palletConfig = palletTypesData.find(findPredicate(pallet));
      return { ...pallet, ...palletConfig! };
   });
